<script setup>
import { __, requestSelfcareAccountSubscriber } from '@/utils';
import { inject, ref, onMounted, computed, watch } from 'vue';
import Loader from '@components/loader.vue';
import settingsTables from '@components/settingsTables/settingsTables.vue';
import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
	ComboboxButton,
} from '@headlessui/vue';

const { details } = inject('account');
const searchParams = new URLSearchParams(window.location.search);
const subscribersArray = computed(() => details.value?.subscribers.filter(sub => sub.name !== currentSubscriber.value.name));
const subscriberID = searchParams.size > 0 ? details.value?.subscribers.find(sub => sub.name === searchParams.get('subscriber_id')) : details.value?.subscribers?.[0];

const currentSubscriber = ref(subscriberID);
const nc_data = ref({});
const loader = ref(false);
const hasNcData = ref(false);

const getSubscriber = async (id) => {
    loader.value = true;
    let [data, error] = await requestSelfcareAccountSubscriber(id);
    loader.value = false;

    if (error) {
        console.error(error);
    } else if (data) {
        nc_data.value = data.data?.nc_data;
        hasNcData.value = true;
    }
};

onMounted(() => {
    if (details.value?.subscribers?.[0]?.id) {
        getSubscriber(details.value?.subscribers?.[0]?.id);
    }
});

</script>
<template>
    <div class="account-main account-main--settings">
        <div class="invoice-header">
            <div class="invoice-header__back">
                <a @click.prevent="$router.back()" class="link-underline">
                    <img :src="`${theme_path.url}/resources/images/svg/icon-arrow-right.svg`" />
                    {{ __('Back to previous page') }}
                </a>
            </div>
            <h2 class="fz52 mb52">{{ __('Manage my line') }}</h2>
            <div class="invoice-header__content invoice-header__content-bottom-marging">
                <div class="cellular-phone-wrapper cellular-phone-wrapper--usages" v-if="details?.subscribers?.length">
                    <h5>{{ __('Select a subscription') }}</h5>
                    <div class="combobox-outer combobox-outer--fullbutton">
                        <Combobox v-model="currentSubscriber" @update:modelValue="getSubscriber(currentSubscriber.id)">
                            <div class="combobox-wrapper">
                                <ComboboxInput
                                    :displayValue="(value) => value.name" 
                                    id="subscription"
                                    name="subscription"
                                    disabled
                                />
                                <ComboboxButton class="combobox-icon" />
                            </div>
                            <ComboboxOptions class="combobox-options notice__options">
                                <ComboboxOption
                                    v-for="option in subscribersArray"
                                    :key="option.id"
                                    :value="option"
                                    class="combobox-option combobox-option--smaller"
                                >
                                    {{ option.name }}
                                </ComboboxOption>
                            </ComboboxOptions>
                        </Combobox>
                    </div>
                </div>
            </div>
        </div>

		<Loader v-if="loader"  color="#2563eb" />
		<settingsTables
            v-if="hasNcData && !loader"
            :nc_data="nc_data"
            :subscriber="currentSubscriber"
        />
    </div>
</template>